import React from "react"
import classNames from "classnames"
import { Avatar, Dropdown, Navbar, NavbarLink } from "flowbite-react"

import "./index.css"
import { IconExternalLink, IconMenu } from "@tabler/icons-react"
import Badge from "design_system/core/components/badge"
import routes from "@love-irish/routes"

export const navigation = [
  { name: "Wiki", href: "/wiki" },
  { name: "Adventure", href: "/wiki/adventure" },
]

export default ({ currentUser, currentPath = "/" }) => {
  return (
    <header className="app-header">
      <div className="container">
        <Navbar fluid rounded className="py-3 px-0!">
          <ul className="mt-0 flex flex-row space-x-2 md:space-x-8 text-sm font-medium overflow-x-auto items-center">
            {navigation.map(
              ({ name, className, translated, href, ...rest }) => {
                const isActive = window.location.pathname == href
                return (
                  <NavbarLink
                    key={name}
                    href={href}
                    className={classNames(
                      "app-nav-link border-0",
                      {
                        active: isActive,
                      },
                      className
                    )}
                    {...rest}
                  >
                    <span>
                      <span
                        className={classNames(
                          "text-md block text-dark-700",
                          isActive ? "font-extrabold" : "font-medium"
                        )}
                      >
                        {name}{" "}
                        {href?.includes("http") && (
                          <IconExternalLink
                            className="inline align-top text-secondary"
                            size={12}
                          />
                        )}
                      </span>
                      <em className="text-xs">{translated}</em>
                    </span>
                  </NavbarLink>
                )
              }
            )}
          </ul>
        </Navbar>
      </div>
    </header>
  )
}
